export default __webpack_public_path__ + "static/media/imageone.52c899b9.png";